import useAppInfo from './useAppInfo';

export default useAppInfo;
